import { render, staticRenderFns } from "./GridTableComponent.vue?vue&type=template&id=12b928fb&lang=pug"
import script from "./GridTableComponent.vue?vue&type=script&lang=js"
export * from "./GridTableComponent.vue?vue&type=script&lang=js"
import style0 from "./GridTableComponent.vue?vue&type=style&index=0&id=12b928fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports